import React from 'react';
import { RiArrowLeftLine } from '@remixicon/react';

// Shared chrome for every /track screen (landing + detail + state cards): the
// branded gradient hero and the mobile-first max-w container that overlaps it.
// Kept in one place so the header never drifts between screens.
export const TRACK_HERO_GRADIENT =
  'linear-gradient(135deg, var(--primary-base) 0%, var(--primary-dark) 100%)';

export const TrackShell: React.FC<{
  children: React.ReactNode;
  /** When provided, a back arrow shows in the hero (detail screens → /track). */
  onBack?: () => void;
}> = ({ children, onBack }) => (
  <div className="min-h-screen bg-bg-weak-50">
    <div
      className="relative px-4 pb-12 pt-8 text-center"
      style={{ background: TRACK_HERO_GRADIENT }}
    >
      {onBack && (
        <button
          type="button"
          onClick={onBack}
          aria-label="Kembali ke pencarian"
          className="absolute left-3 top-7 flex size-9 items-center justify-center rounded-full text-static-white transition-colors hover:bg-static-white/15"
        >
          <RiArrowLeftLine className="size-5" />
        </button>
      )}
      <div className="text-xl font-extrabold tracking-tight text-static-white">
        DASH
      </div>
      <div className="mt-0.5 text-xs font-medium text-static-white/80">
        Lacak Pengiriman
      </div>
    </div>
    {/* relative z-10: the hero is positioned (for the back arrow), so without a
        stacking context here it would paint OVER this overlapping (-mt-8) card. */}
    <div className="relative z-10 mx-auto -mt-8 flex max-w-md flex-col gap-4 px-4 pb-10">
      {children}
    </div>
  </div>
);

export default TrackShell;
